import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { AppRoute } from 'src/constants';
import type { PrivateRouteProps } from './private-route.props';

const PrivateRoute = ({
  isRedirect,
  redirectRoute = AppRoute.MAIN_PAGE_ROUTE,
}: PrivateRouteProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isRedirect) {
      navigate(redirectRoute);
    }
  }, [isRedirect, navigate, redirectRoute]);

  return <Outlet />;
};

export default PrivateRoute;
